module.exports = __webpack_public_path__ + "img/case-study-post-quantum.544f41bd.png";